export const resources = {
    app: {
        label_login: 'Přihlásit',
        label_logout: 'Odhlásit'
    },
    component: {
        status_overlay: {
            title: 'Načítám…'
        },
        upload_manager: {
            err_fragments_merge: 'Chyba spojování fragmentů',
            err_fragments_not_all_uploaded: 'Nebyly nahrány všechny fragmenty',
            err_fragments_upload: 'Nebyly nahrány všechny fragmenty',
            status_merged: 'Vytvořeno',
            status_merging: 'Vytvářím',
            status_uploaded: 'Nahráno',
            status_uploading: 'Nahrávám'
        }
    },
    control: {
        combobox: {
            empty_value: {
                none: '(žádný)',
                not_specified: '(nerozhoduje)',
                select: '(vyberte)'
            }
        }
    },
    data: {
        validations: {
            array_value: {
                error: 'Hodnota musí být pole hodnot.'
            },
            between: {
                error: 'Hodnota musí být rovna nebo větší než {min} a rovna nebo menší než {max}.'
            },
            codelist_value: {
                error: 'Hodnota musí být hodnotou z číselníku.'
            },
            datetime_parse: {
                error: 'Hodnota musí odpovídat očekávanému formátu data a času.'
            },
            datetime_range: {
                error: 'Hodnota musí být v povoleném rozsahu data a času.'
            },
            email_address: {
                error: 'Hodnota musí být e-mailová adresa.'
            },
            equal: {
                error: 'Hodnota musí být rovna {expected}.'
            },
            float_value: {
                required: 'Hodnota musí být desetinné číslo.'
            },
            greater_than: {
                error: 'Hodnota musí být větší než {expected}.'
            },
            greater_than_or_equal: {
                error: 'Hodnota musí být rovna nebo větší než {expected}.'
            },
            int_value: {
                error: 'Hodnota musí být celé číslo.'
            },
            less_than: {
                error: 'Hodnota musí být menší než {expected}.'
            },
            less_than_or_equal: {
                error: 'Hodnota musí být rovna nebo menší než {expected}.'
            },
            not_equal: {
                error: 'Hodnota nesmí být rovna {expected}.'
            },
            required: {
                error: 'Hodnota je vyžadována.'
            },
            string_value: {
                error: 'Hodnota musí být text.'
            }
        },
        value: {
            false: 'ne',
            true: 'ano',
            undefined: 'N/D'
        }
    },
    module: {
        account: {
            btn_change_password: 'Změnit heslo',
            btn_reset_password: 'Resetovat heslo',
            btn_verify: 'Ověřit',
            email_verification_error: 'Při ověřování Vašeho e-mailu došlo k chybě aplikace. Opakujte, prosím, svůj požadavek později.',
            email_verification_fail: 'Váš e-mail se nepodařilo ověřit.',
            email_verification_msg: 'Probíhá ověřování Vašeho e-mailu.',
            email_verification_success: 'Váš e-mail byl úspěšně ověřen.',
            email_verification_title: 'Ověření e-mailu',
            lbl_back_to_login_page: 'Zpět na přihlašovací stránku',
            msg_password_changed: 'Heslo bylo změněno.',
            msg_proceed_to_login_page: 'Pokračovat na stránku přihlášení',
            password_reset_error: 'Při resetu Vašeho hesla došlo k chybě aplikace. Opakujte, prosím, svůj požadavek později.',
            password_reset_fail: 'Vaše heslo se nepodařilo změnit. Vypršela platnost odkazu pro změnu hesla nebo byl odkaz již použit.',
            password_reset_instructions: 'Zadejte, prosím, resetovací kód, své nové přihlašovací heslo a ověření nového přihlašovacího hesla.',
            password_reset_start_instructions: 'Zadejte, prosím, e-mail, který jste použili při registraci.',
            password_reset_start_success: 'Reset hesla byl úspěšně zahájen.',
            password_reset_start_success_instructions: 'Na e-mail uvedený v předchozím kroku Vám byla odeslána zpráva s odkazem pro dokončení procesu resetu hesla. Po odbržení zprávy, prosím, postupujte podle uvedených instrukcí.',
            password_reset_success: 'Vaše heslo bylo úspěšně změněno.',
            password_reset_success_msg: 'Nyní se můžete přihlásit.',
            password_reset_title: 'Reset hesla',
            registration_email_verification_msg: 'Probíhá ověření Vaší e-mailové adresy.',
            registration_email_verification_success_msg: 'Ověřením e-mailové adresy byl dokončen proces registrace. Nyní se můžete přihlásit.',
            registration_email_verification_sucess: 'Vaše e-mailová adresa byla úspěšně ověřena.',
            registration_error: 'Při vytváření Vašeho účtu došlo k chybě aplikace. Opakujte, prosím, svůj požadavek později.',
            registration_fail: 'Váš účet se nepodařilo vytvořit.',
            registration_success: 'Vytvoření Vašeho účtu proběhlo úspěšně.',
            registration_success_msg: 'Pro dokončení registrace je nutné ověřit Vaši e-mailovou adresu. Proto Vám byla odeslána zpráva obsahující ověřovací kód. Po odbržení zprávy, prosím, postupujte podle ve zprávě uvedených instrukcí.',
            registration_title: 'Registrace',
            title_account_details: 'Detaily účtu',
            title_password_change: 'Změna hesla',
            title_personal_information: 'Osobní údaje',
            title_registration: 'Registrace'
        },
        auth: {
            btn_login: 'Přihlásit',
            lbl_back_to_login_page: 'Zpět na přihlašovací stránku',
            lbl_password: 'Heslo',
            lbl_register: 'Registrovat',
            lbl_reset_password: 'Resetovat heslo',
            lbl_username: 'Přihlašovací jméno',
            msg_logged_out: 'Byli jste odhlášeni.',
            msg_logging_out: 'Probíhá odhlašování…',
            title_logged_out: 'Odhlášení',
            title_login: 'Přihlášení'
        }
    },
    page: {
        error_401: {
            description: 'Nejste přihlášeni do aplikace.',
            recommendation: 'Použijte přihlašovací stránku a pak zkuste požadovaný modul znovu otevřít.',
            title: 'Neautorizováno (#401)'
        },
        error_403: {
            description: 'Nemáte dostatečná oprávnění pro přístup k požadovanému modulu.',
            recommendation: 'Tato chyba se nejčastěji vyskytuje v případě, že nemáte přidělenu žádnou aplikační roli. Kontaktujte administrátora aplikace a požádejte o přidělení role.',
            title: 'Zamítnuto (#403)'
        },
        error_404: {
            description: 'Požadovaný modul nebyl nalezen.',
            recommendation: 'Překontrolujte URL adresu ve vašem prohlížeči, zda neobsahuje nechtěný překlep. Případně kontaktujte administrátora aplikace.',
            title: 'Nenalezeno (#403)'
        }
    }
};
